var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcomePackage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "186px",
    height: "230px",
    viewBox: "0 0 186 230",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration/video-legitimation_magenta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-43.1078969%",
    y1: "59.4163017%",
    x2: "99.9993638%",
    y2: "49.9972399%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFE0",
    offset: "38.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEB",
    offset: "60.2894%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9",
    stopOpacity: 0.24,
    offset: "97.627%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.2473555%",
    y1: "50.0019174%",
    x2: "43.1718521%",
    y2: "50.0019174%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBCBD",
    offset: "39.62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    offset: "60.76%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.18896538%",
    y1: "49.1333659%",
    x2: "95.5272465%",
    y2: "50.8612503%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Operationsportal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Verbundene-Personen-\\xFCberpr\\xFCfen",
    transform: "translate(-1212, -1811)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info_icon",
    transform: "translate(1212, 1867.4205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.743989,21.3472999 L80.5119632,21.3472999 L154.984133,64.8996193 C158.345447,66.8670198 158.345447,71.7765377 154.984133,73.7439382 L80.5119632,117.291766 L105.743989,117.291766 C108.200675,117.291766 110.617451,116.635966 112.745987,115.391742 L120.931984,110.603502 L181.821431,74.9926537 C186.136151,72.4682721 186.136151,66.16181 181.821431,63.6374285 L112.745987,23.2428319 C110.617451,21.9986083 108.20511,21.3472999 105.743989,21.3472999 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.010552,70.2089057 C160.881953,68.2459969 159.41415,66.2022361 156.660356,64.5941781 L90.0415984,25.6728861 C84.7690361,22.5915235 76.7914588,22.2591317 72.2284087,24.931742 L3.07755328,65.4071906 C0.895803388,66.6828568 -0.106382538,68.4121929 0.00891318827,70.2089057 C0.137512267,72.1718145 1.60531555,74.2155754 4.35909188,75.8236334 L70.9778935,114.744925 C76.2504558,117.826288 84.2280331,118.15868 88.7910832,115.486069 L157.937478,75.0106208 C160.119227,73.7349547 161.125848,72.0056186 161.010552,70.2089057 Z",
    id: "Path",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.010552,68.7535683 L161.019421,68.7490765 L161.019421,62.0563212 L133.982573,75.3609798 L90.0371639,49.6859532 C84.7646017,46.6045907 76.7870243,46.2721988 72.2239743,48.9448092 L27.0766956,75.3789469 L0.0088200648,62.0563212 L0.0088200648,68.2504887 C-4.88371953e-05,68.4166847 -4.88371953e-05,68.5828806 0.0088200648,68.7490765 C0.137419144,70.7119853 1.60522242,72.7557462 4.35900319,74.3638042 L70.9778935,113.285096 C73.7139498,114.884171 77.1728216,115.737609 80.5119632,115.822953 C83.60721,115.899313 86.59603,115.31089 88.7910832,114.02624 L157.937478,73.5507916 C160.119227,72.2751255 161.121413,70.5457894 161.010552,68.7535683 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.010552,62.0563212 C160.881953,60.0934124 159.41415,58.0496515 156.660356,56.4415935 L90.0415984,17.5203015 C84.7690361,14.438939 76.7914588,14.1065471 72.2284087,16.7791575 L3.07755328,57.2546061 C0.895803388,58.5302722 -0.106382538,60.2596083 0.00891318827,62.0563212 C0.137512267,64.01923 1.60531555,66.0629908 4.35909188,67.6710488 L70.9778935,106.592341 C76.2504558,109.673703 84.2280331,110.006095 88.7910832,107.333485 L157.937478,66.8580363 C160.119227,65.5823701 161.125848,63.853034 161.010552,62.0563212 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.010552,60.6953112 C160.881953,58.7324024 159.41415,56.6886416 156.660356,55.0805836 L90.0415984,16.1592916 C84.7690361,13.077929 76.7914588,12.7455371 72.2284087,15.4181475 L3.07755328,55.8980879 C0.895803388,57.173754 -0.106382538,58.9030901 0.00891318827,60.699803 C0.137512267,62.6627118 1.60531555,64.7064726 4.35909188,66.3145306 L70.9778935,105.235823 C76.2504558,108.317185 84.2280331,108.649577 88.7910832,105.976967 L157.937478,65.5015181 C160.119227,64.2213602 161.125848,62.492024 161.010552,60.6953112 Z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2969236,3.1645659 C72.9778309,-0.532170779 67.2573892,-0.878038002 63.1156119,1.54303256 L53.3908609,7.22962871 C57.5326381,4.80855815 63.2530799,5.15891716 69.5721726,8.85116205 C82.2103579,16.2446354 92.4583742,34.2207474 92.4583742,49.0032024 C92.4583742,56.3921839 89.8952615,61.5846841 85.7579187,64.0057546 L95.4826697,58.3191585 C99.624447,55.8980879 102.183125,50.7055878 102.183125,43.3121144 C102.183125,28.5341513 91.935109,10.5580393 79.2969236,3.1645659 Z",
    id: "Path",
    fill: "#002D96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4583742,49.0032024 C92.4583742,56.3921839 89.8952615,61.5846841 85.7579187,64.0057546 C81.6161415,66.4268252 75.8956997,66.0764662 69.5721726,62.3842213 C56.9339872,54.9952397 46.6904054,37.0191277 46.6904054,22.2366728 C46.6904054,14.8431994 49.2535181,9.65069927 53.3952953,7.22962871 C57.5370726,4.80855815 63.2575144,5.15891716 69.576607,8.85116205 C82.2103579,16.2446354 92.4583742,34.2207474 92.4583742,49.0032024 Z",
    id: "Path",
    fill: "#003DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2128568,48.1407802 L72.5831648,47.7724541 L72.5831648,30.1107668 C72.5831648,28.1658251 71.2350917,25.798656 69.5721726,24.8239392 L66.5390081,23.0496853 C64.876089,22.0749686 63.5280159,22.8655222 63.5280159,24.8104639 C63.5280159,26.7554056 64.876089,29.1225747 66.5390081,30.0972914 L66.5611803,30.1107668 L66.5611803,44.2464051 L65.9359228,43.8825708 C64.2730036,42.907854 62.9249305,43.6984077 62.9249305,45.6433493 C62.9249305,47.588291 64.2730036,49.9554602 65.9359228,50.9301769 L73.2128568,55.1883863 C74.875776,56.1631031 76.2238491,55.3725494 76.2238491,53.4276077 C76.2238491,51.4781743 74.875776,49.1110051 73.2128568,48.1407802 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2307198,23.3686018 C70.9512868,24.374761 72.3481389,23.5572567 72.3481389,21.5449383 C72.3481389,19.5326199 70.9512868,17.0801069 69.2307198,16.0739477 C67.5101529,15.0677885 66.1132903,15.8808011 66.1132903,17.8976112 C66.1088663,19.9099296 67.5101529,22.3624427 69.2307198,23.3686018 Z",
    id: "Path",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomePackage);
export default __webpack_public_path__ + "static/media/welcome-package.98b730c6be1069ea82963646efe57f62.svg";
export { ForwardRef as ReactComponent };